import { render, staticRenderFns } from "./EmptyUser.vue?vue&type=template&id=edce4ba4&scoped=true&"
import script from "./EmptyUser.vue?vue&type=script&lang=ts&"
export * from "./EmptyUser.vue?vue&type=script&lang=ts&"
import style0 from "./EmptyUser.vue?vue&type=style&index=0&id=edce4ba4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edce4ba4",
  null
  
)

export default component.exports